type Props = {
  message: string;
  onRetry?: () => void;
  retryLabel?: string;
};

/** Компактная ошибка загрузки CRM-блока. */
export function CrmInlineError({ message, onRetry, retryLabel = 'Повторить' }: Props) {
  return (
    <div
      className="rounded-xl px-3 py-3 space-y-2"
      style={{ background: 'rgba(252,129,74,0.1)', border: '1px solid rgba(252,129,74,0.35)' }}
    >
      <p className="text-xs leading-snug" style={{ color: '#FC814A' }}>
        {message}
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="press text-[11px] font-bold underline touch-manipulation min-h-[40px]"
          style={{ color: '#63B3ED' }}
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
}
